import "select2";

(function( $ ) {

	"use strict";
    jQuery(document).ready(function () {
        jQuery('select.custom-select')
          .each(function () {
            const $select = jQuery(this);
            const $parent = $select.closest('.select2-parent'); // Find the closest parent wrapper
      
            $select.select2({
              minimumResultsForSearch: Infinity,
              dropdownParent: $parent,
              dropdownCssClass: 'dropdown-right'
            });
          });
      });
      

})(jQuery);